import React, { Component } from 'react';
import {runtime} from 'rest/runtime';
import { Panel } from 'widgets/default/panel';
import { Header } from 'widgets/default/Header';
import { PanelBody } from 'widgets/default/panel/body';
import Table from '../table/Table';
import TableBody from '../table/Body';
import TableRow from '../table/Row';
import TableColumn from '../table/Column';
import { actions } from 'actions';
import { LiveItem } from './LiveItem';

class TechnicalWidget extends Component {
  state = {
    liveFields: [],
    saved: false
  }

  componentWillMount() {
    const { supplier } = this.props;

    this.setState({
      liveFields: this.getLiveFields(supplier),
    })
  }

  liveSettingDefaults = {
    voxover: {type: 'checkbox', title: 'Voxover'},
    voxoverlicense: {type: 'text', title: 'Voxover license'},
    word2wav: {type: 'checkbox', title: 'Word2WAV'},
    word2wavlicense: {type: 'text', title: 'Word2WAV license'},
  }

  getLiveFields(attributes) {
    return _.map(_.pick(attributes, Object.keys(this.liveSettingDefaults)), (val, key) => {
      return  _.extend(this.liveSettingDefaults[key], {value: val, originalValue: val, name: key});
    });
  }

  handleSave = () => {
    this.setSaved();
  }

  setSaved() {
    this.setState({saved: true});
    setTimeout(this.unsetSaved, 2000);
  }

  unsetSaved = () => {
    this.setState({saved: false});
  }

  render() {
    var h1Styling = {padding: '8 15', fontSize: 12, color: '#333', fontWeight: 'bold'};
    const { supplier: { uid: supplierId } } = this.props;

    return (
      <Panel>
        <Header title="Technical Capabilities" saved={this.state.saved} onSave={this.handleSave} />
        <PanelBody>
          <Table margin="0">
            <TableBody>
              {this.state.liveFields.map((field => (
                <LiveItem
                  key={field.name}
                  handleSave={this.handleSave}
                  supplierId={supplierId}
                  title={field.title}
                  value={field.value}
                  fieldKey={field.name}
                  type={field.type}
                />
              )))}
            </TableBody>
          </Table>
        </PanelBody>
      </Panel>
    );
  }
}

export { TechnicalWidget };
